/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response object for an institute header
 * @export
 * @interface InstituteHeader
 */
export interface InstituteHeader {
    /**
     * Unique identifier of the institute header
     * @type {string}
     * @memberof InstituteHeader
     */
    instituteHeaderId?: string;
    /**
     * First custom line of the institute header
     * @type {string}
     * @memberof InstituteHeader
     */
    customLine1?: string;
    /**
     * Second custom line of the institute header
     * @type {string}
     * @memberof InstituteHeader
     */
    customLine2?: string;
    /**
     * Creation timestamp
     * @type {string}
     * @memberof InstituteHeader
     */
    created?: string;
}

/**
 * Check if a given object implements the InstituteHeader interface.
 */
export function instanceOfInstituteHeader(value: object): value is InstituteHeader {
    return true;
}

export function InstituteHeaderFromJSON(json: any): InstituteHeader {
    return InstituteHeaderFromJSONTyped(json, false);
}

export function InstituteHeaderFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstituteHeader {
    if (json == null) {
        return json;
    }
    return {
        
        'instituteHeaderId': json['instituteHeaderId'] == null ? undefined : json['instituteHeaderId'],
        'customLine1': json['customLine1'] == null ? undefined : json['customLine1'],
        'customLine2': json['customLine2'] == null ? undefined : json['customLine2'],
        'created': json['created'] == null ? undefined : json['created'],
    };
}

export function InstituteHeaderToJSON(json: any): InstituteHeader {
    return InstituteHeaderToJSONTyped(json, false);
}

export function InstituteHeaderToJSONTyped(value?: InstituteHeader | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'instituteHeaderId': value['instituteHeaderId'],
        'customLine1': value['customLine1'],
        'customLine2': value['customLine2'],
        'created': value['created'],
    };
}

